import {
  AlertCircle,
  AlertTriangle,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  BadgeCheck,
  BarChart3,
  Bell,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarPlus,
  Camera,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  Circle,
  CreditCard,
  Home,
  Inbox,
  Info,
  ListChecks,
  Menu,
  MessageCircle,
  MoreHorizontal,
  Network,
  Phone,
  Plus,
  ReceiptText,
  RotateCcw,
  Scissors,
  Search,
  Send,
  SlidersHorizontal,
  Star,
  StickyNote,
  Store,
  Unlink,
  User,
  UserX,
  Users,
  WalletCards,
  type LucideIcon,
} from "lucide-react";

const ICONS: Record<string, LucideIcon> = {
  dashboard: Home,
  inbox: Inbox,
  calendar_month: Calendar,
  calendar_today: Calendar,
  event: Calendar,
  event_available: CalendarCheck,
  event_upcoming: CalendarClock,
  calendar_add_on: CalendarPlus,
  schedule: CalendarClock,
  group: Users,
  groups: Users,
  group_off: UserX,
  person: User,
  payments: WalletCards,
  credit_card: CreditCard,
  receipt_long: ReceiptText,
  query_stats: BarChart3,
  bar_chart: BarChart3,
  tune: SlidersHorizontal,
  store: Store,
  storefront: Store,
  category: ListChecks,
  block: AlertCircle,
  content_cut: Scissors,
  rule: ListChecks,
  chat: MessageCircle,
  chat_bubble: MessageCircle,
  forum: MessageCircle,
  notifications_active: Bell,
  hub: Network,
  schema: Network,
  chevron_left: ChevronLeft,
  chevron_right: ChevronRight,
  expand_more: ChevronDown,
  keyboard_double_arrow_left: ChevronsLeft,
  keyboard_double_arrow_right: ChevronsRight,
  arrow_back: ArrowLeft,
  arrow_forward: ArrowRight,
  arrow_outward: ArrowUpRight,
  menu: Menu,
  search: Search,
  replay: RotateCcw,
  priority_high: AlertCircle,
  warning: AlertTriangle,
  info: Info,
  loyalty: Star,
  sticky_note_2: StickyNote,
  photo_camera: Camera,
  call: Phone,
  more_horiz: MoreHorizontal,
  send: Send,
  add: Plus,
  verified: BadgeCheck,
  check_circle: CheckCircle2,
  radio_button_unchecked: Circle,
  link_off: Unlink,
};

export function SalonIcon({
  name,
  className,
}: {
  name: string;
  className?: string;
}) {
  const Icon = ICONS[name] ?? Circle;
  return (
    <Icon
      aria-hidden="true"
      className={className ? `cd-salon-icon ${className}` : "cd-salon-icon"}
      focusable="false"
      strokeWidth={1.8}
    />
  );
}
